'use client'

import { Heading, HeadingProps } from '@chakra-ui/react'
import { FC, ReactNode } from 'react'

export type SectionTitleProps = HeadingProps & {
  children: ReactNode
}

export const SectionTitle: FC<SectionTitleProps> = ({ children, ...props }) => {
  return (
    <Heading
      as="h2"
      fontFamily="display"
      fontSize={{ base: '2rem', md: '2.4rem', lg: '2.8rem' }}
      fontWeight={500}
      lineHeight={1.2}
      letterSpacing="-0.02em"
      mb={6}
      {...props}
    >
      {children}
    </Heading>
  )
}
